import React, { Fragment } from 'react';
import LoginTabset from './loginTabset';
import Slider from 'react-slick';
import stats from '../../assets/images/dashboard/login-logo.png';
import '../../assets/scss/slick.scss';
import '../../assets/scss/slick-theme.scss';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

const Login = () => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
  };
  return (
    <Fragment>
      {!localStorage.getItem('ad@#t') ? (
        <div className='page-wrapper user-login-page'>
          <div className='authentication-box'>
            <Container>
              <h3 className='text-left'>
            Hi nix, <br/>These days we are facing issue with Freelancer
            account, so we are unable to reach you, so I am adding this message
            here So if you can provide your email of whatsapp number we can
            connect and continue our communication unless this issue get
            resolved.<br /> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; My email is : er.ashrafkamal@gmail.com and whatsapp number is : +91 9140505474<br/><br />--<br/> Thanks
          </h3>
              <Row>
                <Col className='col-md-5 p-0 card-left'>
                  <Card className='bg-primary login-card'>
                    <div className='svg-icon svg-circle-icon'>
                      <img alt='' src={stats} className='Img-fluid' />
                    </div>
                    <Slider className='single-item' {...settings}>
                      <div>
                        <div>
                          <h3>Welcome to RustyRoyal</h3>
                          {/* <p>
                            Lorem Ipsum is simply dummy text of the printing and
                            typesetting industry. Lorem Ipsum has been the
                            industry's standard dummy.
                          </p> */}
                        </div>
                      </div>
                    </Slider>
                  </Card>
                </Col>
                <Col className='col-md-7 p-0 card-right'>
                  <Card className='tab2-card'>
                    <CardBody className='loging-card-body'>
                      <LoginTabset />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              {/* <a
							href="https://Versuz-react.vercel.app/"
							target="_blank"
							rel="noreferrer"
							className="btn btn-primary back-btn"
						>
							<ArrowLeft />
							back
						</a> */}
            </Container>
          </div>
        </div>
      ) : (
        <Redirect to='/dashboard' />
      )}
    </Fragment>
  );
};

export default Login;
